import { render, staticRenderFns } from "./TableWarningError.vue?vue&type=template&id=ab4287f4&"
import script from "./TableWarningError.vue?vue&type=script&lang=js&"
export * from "./TableWarningError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports